import { Outlet, Link } from 'react-router-dom'
import { Truck } from 'lucide-react'

export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Lado esquerdo - Formulário */}
      <div className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-20 xl:px-24">
        <div className="mx-auto w-full max-w-sm lg:max-w-md">
          {/* Logo */}
          <div className="flex items-center gap-2 mb-8">
            <Truck className="w-10 h-10 text-primary-600" />
            <span className="text-2xl font-bold text-gray-900">EntregaFácil</span>
          </div>

          {/* Conteúdo (Login ou Register) */}
          <Outlet />

          <Link to="/privacidade" className="block mt-8 text-xs text-gray-500 hover:text-gray-700">
            Política de Privacidade
          </Link>
        </div>
      </div>

      {/* Lado direito - Imagem/Info */}
      <div className="hidden lg:flex lg:flex-1 lg:flex-col lg:justify-center bg-primary-600 text-white p-12">
        <div className="max-w-md">
          <h2 className="text-3xl font-bold mb-6">
            Gerencie suas entregas de forma simples
          </h2>
          <p className="text-primary-100 text-lg mb-8">
            Otimize rotas, notifique clientes automaticamente e acompanhe 
            todas as suas entregas em um só lugar.
          </p>
          
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary-500 rounded-full flex items-center justify-center">
                ✓
              </div>
              <span>Rotas otimizadas automaticamente</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary-500 rounded-full flex items-center justify-center">
                ✓
              </div>
              <span>Notificações via WhatsApp</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary-500 rounded-full flex items-center justify-center">
                ✓
              </div>
              <span>Rastreamento em tempo real</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
